export default __webpack_public_path__ + "static/nautil_logo-2b92986cdf8e775d3bb8e6701658c065.png";